import { GetBrokerRole, GetBrokerRoleVariables } from "_graphql/visal/queries/__generated__/GetBrokerRole";
import { getRole, getRoles } from "_graphql/visal/queries/employees";

import { BrokerRoles } from "_graphql/visal/queries/__generated__/BrokerRoles";
import { useQuery } from "@apollo/client";

export const useRoles = () => {
  const { data, ...rest } = useQuery<BrokerRoles>(getRoles);
  return {
    roles: data?.rows || [],
    count: data?.count || 0,
    ...rest,
  };
};

export const useRole = (userRoleId: string) => {
  const { data, ...rest } = useQuery<GetBrokerRole, GetBrokerRoleVariables>(getRole, {
    variables: { brokerRoleId: userRoleId },
    fetchPolicy: "network-only",
    skip: !userRoleId,
  });
  return {
    role: data?.getBrokerRole,
    ...rest,
  };
};
